/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Move_Item_Dialog_SubtitleInputs */



/**
* | type | output |
* | --- | --- |
* | "airHandlerUnit" | "Select one or more ventilation units to move on the plan" |
* | "boilerRoom" | "Select one or more boilers to move on the plan" |
* | "gateway" | "Select one or more gateways to move on the plan" |
* | "multisensor" | "Select one or more multisensors to move on the plan or to another room" |
* | "room" | "Select one or more rooms to move on the plan" |
* | "valve" | "Select one or more heads to move on the plan or to another room" |
* | * | "Select one or more rooms to move on the plan" |
*
* @param {Move_Item_Dialog_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const move_item_dialog_subtitle = /** @type {((inputs: Move_Item_Dialog_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Move_Item_Dialog_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.type === "airHandlerUnit") return /** @type {LocalizedString} */ (`Select one or more ventilation units to move on the plan`);
		if (i?.type === "boilerRoom") return /** @type {LocalizedString} */ (`Select one or more boilers to move on the plan`);
		if (i?.type === "gateway") return /** @type {LocalizedString} */ (`Select one or more gateways to move on the plan`);
		if (i?.type === "multisensor") return /** @type {LocalizedString} */ (`Select one or more multisensors to move on the plan or to another room`);
		if (i?.type === "room") return /** @type {LocalizedString} */ (`Select one or more rooms to move on the plan`);
		if (i?.type === "valve") return /** @type {LocalizedString} */ (`Select one or more heads to move on the plan or to another room`);
		return /** @type {LocalizedString} */ (`Select one or more rooms to move on the plan`)
	}
	{
		if (i?.type === "airHandlerUnit") return /** @type {LocalizedString} */ (`Sélectionnez un ou plusieurs équipements de ventilation à déplacer sur le plan`);
		if (i?.type === "boilerRoom") return /** @type {LocalizedString} */ (`Sélectionnez une ou plusieurs chaudières à déplacer sur le plan`);
		if (i?.type === "gateway") return /** @type {LocalizedString} */ (`Sélectionnez une ou plusieurs box à déplacer sur le plan`);
		if (i?.type === "multisensor") return /** @type {LocalizedString} */ (`Sélectionnez une ou plusieurs multicapteurs à déplacer sur le plan ou vers une autre pièce`);
		if (i?.type === "room") return /** @type {LocalizedString} */ (`Sélectionnez une ou plusieurs pièces à déplacer sur le plan`);
		if (i?.type === "valve") return /** @type {LocalizedString} */ (`Sélectionnez une ou plusieurs têtes à déplacer sur le plan ou vers une autre pièce`);
		return /** @type {LocalizedString} */ (`Sélectionnez une ou plusieurs pièces à déplacer sur le plan`)
	}
});